/**
 * toggle-switch-react-native
 * Toggle Switch component for react native, it works on iOS and Android
 * https://github.com/aminebenkeroum/toggle-switch-react-native
 * Email:amine.benkeroum@gmail.com
 * Blog: https://medium.com/@aminebenkeroum/
 */

import React from "react";
import { StyleSheet, View, TouchableOpacity, Platform } from "react-native";
import Text from "../components_v2/TextFont";

import PropTypes from "prop-types";
import { getIsRTL } from "../util";

const IS_WEB = Platform.OS === "web";
/**@augments{Component<Props,state>} */
class ToggleSwitch extends React.Component {
  static calculateDimensions(size) {
    switch (size) {
      case "small":
        return {
          width: 40,
          padding: 10,
          circleWidth: 15,
          circleHeight: 15,
          translateX: 43,
        };
      case "large":
        return {
          width: 70,
          padding: 20,
          circleWidth: 30,
          circleHeight: 30,
          translateX: 75,
        };
      default:
        return {
          width: 46,
          padding: 12,
          circleWidth: 18,
          circleHeight: 18,
          translateX: 50,
        };
    }
  }

  static propTypes = {
    isOn: PropTypes.bool.isRequired,
    label: PropTypes.string,
    labelPosition: PropTypes.string,
    onColor: PropTypes.string,
    offColor: PropTypes.string,
    size: PropTypes.string,
    labelStyle: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
      PropTypes.number,
    ]),
    thumbOnStyle: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
      PropTypes.number,
    ]),
    thumbOffStyle: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
      PropTypes.number,
    ]),
    trackOnStyle: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
      PropTypes.number,
    ]),
    trackOffStyle: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
      PropTypes.number,
    ]),
    onToggle: PropTypes.func,
    icon: PropTypes.object,
    disabled: PropTypes.bool,
    animationSpeed: PropTypes.number,
    useNativeDriver: PropTypes.bool,
    circleColor: PropTypes.string,
    hitSlop: PropTypes.oneOfType([
      PropTypes.shape({
        top: PropTypes.number,
        bottom: PropTypes.number,
        left: PropTypes.number,
        right: PropTypes.number,
      }),
      PropTypes.number,
    ]),
  };

  static defaultProps = {
    isOn: false,
    onColor: "#4cd137",
    offColor: "#ecf0f1",
    size: "medium",
    labelStyle: {},
    labelPosition: "left",
    thumbOnStyle: {},
    thumbOffStyle: {},
    trackOnStyle: {},
    trackOffStyle: {},
    icon: null,
    disabled: false,
    animationSpeed: 300,
    useNativeDriver: true,
    circleColor: "white",
  };

  // offsetX = new Animated.Value(0);
  dimensions = ToggleSwitch.calculateDimensions(this.props.size);

  createToggleSwitchStyle = () => [
    {
      justifyContent: "center",
      width: this.dimensions.width,
      borderRadius: 20,
      padding: this.dimensions.padding,
      backgroundColor: this.props.isOn
        ? this.props.onColor
        : this.props.offColor,
    },
    this.props.isOn ? this.props.trackOnStyle : this.props.trackOffStyle,
  ];

  createInsideCircleStyle = () => [
    {
      alignItems: "center",
      justifyContent: "center",
      margin: IS_WEB ? 0 : 2,
      left: IS_WEB ? (getIsRTL() ? 3 : 22) : 2,
      position: "absolute",
      backgroundColor: this.props.circleColor,
      // transform: [{ translateX: this.offsetX }],
      width: this.dimensions.circleWidth,
      height: this.dimensions.circleHeight,
      borderRadius: this.dimensions.circleWidth / 2,
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.2,
      shadowRadius: 2.5,
      elevation: 1.5,
    },
    this.props.isOn ? { right: 3 } : IS_WEB ? { left: 3 } : { left: 19 },
    this.props.isOn ? this.props.thumbOnStyle : this.props.thumbOffStyle,
  ];

  render() {
    const {
      isOn,
      onToggle,
      disabled,
      labelStyle,
      labelPosition,
      label,
      icon,
      hitSlop,
    } = this.props;

    // let toValue;
    // if (!IsRTL && isOn) {
    //   toValue = this.dimensions.width - this.dimensions.translateX;
    // } else if (IsRTL && isOn) {
    //   toValue = -this.dimensions.width + this.dimensions.translateX;
    // } else if (IsRTL && !isOn) {
    //   if (IS_WEB) {
    //     toValue = this.dimensions.width - this.dimensions.translateX / 2.3;
    //   } else if (this.props.size == "large" && !IS_WEB) {
    //     toValue = this.dimensions.width - this.dimensions.translateX - 24;
    //   } else {
    //     toValue = this.dimensions.width - this.dimensions.translateX - 10;
    //   }
    // } else {
    //   toValue = -1;
    // }

    // Animated.timing(this.offsetX, {
    //   toValue,
    //   duration: animationSpeed,
    //   useNativeDriver: useNativeDriver,
    // }).start();

    return (
      <View style={styles.container} {...this.props}>
        {label && labelPosition === "left" ? (
          <Text style={[styles.labelStyle, labelStyle]}>{label}</Text>
        ) : null}
        <TouchableOpacity
          style={this.createToggleSwitchStyle()}
          activeOpacity={0.8}
          hitSlop={hitSlop}
          onPress={() => (disabled ? null : onToggle(!isOn))}
        >
          <View style={this.createInsideCircleStyle()}>{icon}</View>
          {/* <Animated.View style={this.createInsideCircleStyle()}>
            {icon}
          </Animated.View> */}
        </TouchableOpacity>
        {label && labelPosition === "right" ? (
          <Text style={[styles.labelStyle, labelStyle]}>{label}</Text>
        ) : null}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 5,
  },
  labelStyle: {
    marginHorizontal: 10,
  },
});

export default ToggleSwitch;
